import { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';

export const AuthGuard = ({
  children,
  redirectTo,
}: {
  children: ReactElement;
  redirectTo: string;
}) => {
  const { authState } = useAuth();

  if (authState === 'IDLE') {
    // 起動スプラッシュ。index.html の静的表示（.app-splash）と同一マークアップ・同一CSS
    // （CSS は index.html の <style> が head に常駐）なので、静的→React で見た目が完全一致する。
    return (
      <div className='app-splash'>
        <div className='app-splash__logo' />
        <div className='app-splash__name'>Ecois Admin</div>
        <div className='app-splash__wave'>
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    );
  }

  if (authState === 'UNAUTHENTICATED') {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
